import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { Controller, useWatch } from "react-hook-form";
import "./style.css";
import libForm from "../../../util/libForm";
import { useContext, useRef, useState } from "react";
import { ContextGlobal } from "../../../context";
import LoadingFull from "../../loading/loading-full";
import TextCurrencyInput from "../../inputs/text-currency";
import { CreditCard, Banknote } from "lucide-react";

const ShowTableInstallments = ({ installments, control, setValue, valor_total }) => {
	const { formPaymentData, bankData } = useContext(ContextGlobal);
	const [loading] = useState(false);
	const isProgrammatic = useRef(false);

	// Vigia todas as parcelas na tela principal
	const watchedParcelas = useWatch({
		control,
		name: "parcelas",
	});

	const handleFieldChange = (index, field, value) => {
		setValue(`parcelas.${index}.${field}`, value, { shouldValidate: true });

		if (field === "id_forma") {
			const idForma = Number(value);
			// Se for Pix, Débito ou Crédito na tela principal, força a data para hoje
			if ([3, 4, 5].includes(idForma)) {
				setValue(`parcelas.${index}.data_vencimento`, new Date().toISOString().split("T")[0], {
					shouldValidate: true,
				});
			}

			// Se for Pix (3), Débito (4) ou Crédito (5), muda o status para "Pago" (ativo: false)
			// Caso contrário (como Vale ID 2), muda para "Pendente" (ativo: true) na tela principal
			if ([3, 4, 5].includes(idForma)) {
				setValue(`parcelas.${index}.ativo`, false, { shouldValidate: true });
			} else {
				setValue(`parcelas.${index}.ativo`, true, { shouldValidate: true });
			}
		}

		if (!isProgrammatic.current && field === "valor") {
			// setLastChangedIndex(index);
		}
	};

	// const handleValorBlur = async () => {
	// 	if (lastChangedIndex === null || lastChangedIndex === -1) return;

	// 	try {
	// 		setLoading(true);

	// 		const somaAteAlterada = installments
	// 			.slice(0, lastChangedIndex + 1)
	// 			.reduce((acc, parcela) => acc + parseFloat(parcela.valor || 0), 0);

	// 		const startIndex = lastChangedIndex + 1;
	// 		const belowCount = installments.length - startIndex;
	// 		const valorRestante = valor_total - somaAteAlterada;

	// 		isProgrammatic.current = true; // 👈 inicia modo interno

	// 		if (valorRestante < 0) {
	// 			// ⚠️ Excedeu o total, corrige na parcela alterada
	// 			const parcelaAtual = parseFloat(installments[lastChangedIndex].valor) || 0;
	// 			const total = installments.reduce((acc, parcela) => acc + parseFloat(parcela.valor || 0), 0);
	// 			const diff = valor_total - total;
	// 			const newValue = parcelaAtual + diff;

	// 			setValue(`parcelas.${lastChangedIndex}.valor`, parseFloat(newValue.toFixed(2)), {
	// 				shouldValidate: true,
	// 			});
	// 			toast.error("Valor excede o total. Diferença corrigida na parcela alterada.");
	// 		} else if (belowCount > 0) {
	// 			// ✅ Rateia o restante
	// 			const valorPorParcela = valorRestante / belowCount;
	// 			for (let i = startIndex; i < installments.length; i++) {
	// 				setValue(`parcelas.${i}.valor`, parseFloat(valorPorParcela.toFixed(2)), {
	// 					shouldValidate: true,
	// 				});
	// 			}
	// 		} else {
	// 			// ✅ Última parcela alterada, ajusta a diferença nela
	// 			const parcelaAtual = parseFloat(installments[lastChangedIndex].valor) || 0;
	// 			const total = installments.reduce((acc, parcela) => acc + parseFloat(parcela.valor || 0), 0);
	// 			const diff = valor_total - total;
	// 			const newValue = parcelaAtual + diff;

	// 			if (parcelaAtual !== newValue) {
	// 				setValue(`parcelas.${lastChangedIndex}.valor`, parseFloat(newValue.toFixed(2)), {
	// 					shouldValidate: true,
	// 				});
	// 				toast.error(
	// 					"Não há parcelas abaixo para ajustar a diferença. Valor corrigido na parcela alterada."
	// 				);
	// 			}
	// 		}
	// 	} catch (error) {
	// 		toast.error("Erro ao corrigir valores das parcelas.");
	// 	} finally {
	// 		isProgrammatic.current = false; // 👈 volta ao normal
	// 		setLoading(false);
	// 		setLastChangedIndex(null);
	// 	}
	// };

	// const handleValorBlur = async () => {
	// 	if (lastChangedIndex === null || lastChangedIndex === -1) return;

	// 	try {
	// 		setLoading(true);

	// 		const somaAteAlterada = installments
	// 			.slice(0, lastChangedIndex + 1)
	// 			.reduce((acc, parcela) => acc + parseFloat(parcela.valor || 0), 0);

	// 		const startIndex = lastChangedIndex + 1;
	// 		const belowCount = installments.length - startIndex;
	// 		const valorRestante = valor_total - somaAteAlterada;

	// 		isProgrammatic.current = true; // 👈 inicia modo interno

	// 		if (belowCount > 0) {
	// 			const valorPorParcela = valorRestante / belowCount;
	// 			for (let i = startIndex; i < installments.length; i++) {
	// 				setValue(`parcelas.${i}.valor`, parseFloat(valorPorParcela.toFixed(2)), {
	// 					shouldValidate: true,
	// 				});
	// 			}
	// 		} else {
	// 			const parcelaAtual = parseFloat(installments[lastChangedIndex].valor) || 0;
	// 			const total = installments.reduce((acc, parcela) => acc + parseFloat(parcela.valor || 0), 0);
	// 			const diff = valor_total - total;
	// 			const newValue = parcelaAtual + diff;

	// 			console.log(parcelaAtual, total, diff, newValue);

	// 			if (parcelaAtual !== newValue) {
	// 				setValue(`parcelas.${lastChangedIndex}.valor`, parseFloat(newValue.toFixed(2)), {
	// 					shouldValidate: true,
	// 				});
	// 				toast.error(
	// 					"Não há parcelas abaixo para ajustar a diferença. Valor corrigido na parcela alterada."
	// 				);
	// 			}
	// 		}
	// 	} catch (error) {
	// 		toast.error("Erro ao corrigir valores das parcelas.");
	// 	} finally {
	// 		isProgrammatic.current = false; // 👈 volta ao normal
	// 		setLoading(false);
	// 		setLastChangedIndex(null);
	// 	}
	// };

	const cellStyle = { padding: "8px" };

	const hasAnyDateInput = installments.some((parcela, index) => {
		const currentIdForma = watchedParcelas?.[index]?.id_forma ?? parcela.id_forma;
		return ![3, 4, 5].includes(Number(currentIdForma));
	});

	return (
		<>
			{loading && <LoadingFull mensagem={"Recalculando Parcelas"} />}
			<TableContainer>
				<Table>
					<TableHead className="color-table">
						<TableRow sx={{ height: "48px" }}>
							<TableCell sx={{ ...cellStyle, color: "white" }}>Parcela</TableCell>
							<TableCell sx={{ ...cellStyle, color: "white" }}>Valor</TableCell>
							<TableCell sx={{ ...cellStyle, color: "white" }}>Forma de Pagamento</TableCell>
							{hasAnyDateInput && <TableCell sx={{ ...cellStyle, color: "white" }}>Data</TableCell>}
							<TableCell sx={{ ...cellStyle, color: "white", textAlign: "center" }}>Status</TableCell>
							<TableCell sx={{ ...cellStyle, color: "white" }}>Conta do pagamento</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{installments.map((parcela, index) => {
							// Usa o valor em tempo real monitorado pelo useWatch
							const currentIdForma = watchedParcelas?.[index]?.id_forma ?? parcela.id_forma;
							const isAutoDateRow = [3, 4, 5].includes(Number(currentIdForma));

							return (
								<TableRow key={parcela.id}>
									<TableCell sx={cellStyle}>
										<span>{index + 1}</span>
									</TableCell>

									<TableCell sx={cellStyle}>
										<Controller
											name={`parcelas.${index}.valor`}
											control={control}
											defaultValue={parcela.valor}
											render={({ field, fieldState }) => (
												<TextCurrencyInput
													label=""
													name={`parcelas.${index}.valor`}
													control={control}
													errors={{ [`parcelas.${index}.valor`]: fieldState.error }}
													className="w-full"
													required
													onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
													readOnly={true} //
													// onValueBlur={handleValorBlur}
													onValueChange={(newValue) =>
														handleFieldChange(index, "valor", parseFloat(newValue || 0))
													}
												/>
											)}
										/>
									</TableCell>

									<TableCell sx={cellStyle}>
										<Controller
											name={`parcelas.${index}.id_forma`}
											control={control}
											defaultValue={parcela.id_forma}
											render={({ field, fieldState }) => (
												<div className="content-select input-select-box d-flex flex-column min-w-52">
													<select
														{...field}
														onChange={(e) =>
															handleFieldChange(
																index,
																"id_forma",
																parseInt(e.target.value),
															)
														}
														onKeyDown={(e) => e.key === "Enter" && libForm.EnterTab(e)}
														className="custom-select"
													>
														{formPaymentData?.map((forma) => (
															<option key={forma.id_forma} value={forma.id_forma}>
																{forma.nome}
															</option>
														))}
													</select>
													{fieldState.error && (
														<p style={{ color: "red" }}>{fieldState.error.message}</p>
													)}
												</div>
											)}
										/>
									</TableCell>

									{hasAnyDateInput && (
										<TableCell sx={cellStyle}>
											{!isAutoDateRow && (
												<Controller
													name={`parcelas.${index}.data_vencimento`}
													control={control}
													defaultValue={
														new Date(parcela.data_vencimento).toISOString().split("T")[0]
													}
													render={({ field, fieldState }) => (
														<TextField
															{...field}
															type="date"
															value={field.value}
															onChange={(e) =>
																handleFieldChange(
																	index,
																	"data_vencimento",
																	e.target.value,
																)
															}
															onClick={(e) => e.target.showPicker()}
															error={!!fieldState.error}
															helperText={fieldState.error?.message}
															onKeyDown={(e) => e.key === "Enter" && libForm.EnterTab(e)}
															sx={{
																width: "100%",
																height: "49px",
																"& .MuiOutlinedInput-root": {
																	"& fieldset": { borderWidth: "1px" },
																	"&:hover fieldset": { borderWidth: "1px" },
																	"&.Mui-focused fieldset": { borderWidth: "1px" },
																},
																"& .MuiInputBase-root": {
																	height: "43px",
																	fontSize: "0.875rem",
																},
															}}
														/>
													)}
												/>
											)}
										</TableCell>
									)}

									<TableCell sx={cellStyle}>
										<Controller
											name={`parcelas.${index}.ativo`}
											control={control}
											defaultValue={parcela.ativo}
											render={({ field, fieldState }) => {
												const idForma = Number(currentIdForma);
												const isCard = [4, 5].includes(idForma);
												const isPix = idForma === 3;

												// Se for Pix ou Cartão, o status é fixo (não clicável)
												if (isCard || isPix) {
													return (
														<div className="flex justify-center items-center">
															<div style={{ cursor: "default" }} title="Pago">
																{isCard ? (
																	<CreditCard
																		size={24}
																		color="#22c55e"
																		strokeWidth={2.5}
																	/>
																) : (
																	<Banknote
																		size={24}
																		color="#22c55e"
																		strokeWidth={2.5}
																	/>
																)}
															</div>
														</div>
													);
												}

												// Para as demais formas, o clique é permitido
												return (
													<div className="flex justify-center items-center">
														<div
															className={`${
																field.value
																	? "badge_status bg_red"
																	: "badge_status bg_green"
															}`}
															onClick={() =>
																handleFieldChange(index, "ativo", !field.value)
															}
															style={{ cursor: "pointer" }}
														>
															{field.value ? "Pendente" : "Pago"}
														</div>
														{fieldState.error && (
															<p style={{ color: "red", fontSize: "10px" }}>
																{fieldState.error.message}
															</p>
														)}
													</div>
												);
											}}
										/>
									</TableCell>

									<TableCell sx={cellStyle}>
										<Controller
											name={`parcelas.${index}.id_conta`}
											control={control}
											defaultValue={parcela.id_conta}
											render={({ field, fieldState }) => (
												<div className="content-select input-select-box d-flex flex-column min-w-52">
													<select
														{...field}
														onChange={(e) =>
															handleFieldChange(
																index,
																"id_conta",
																parseInt(e.target.value),
															)
														}
														onKeyDown={(e) => e.key === "Enter" && libForm.EnterTab(e)}
														className="custom-select"
													>
														{bankData?.map((bank) => (
															<option key={bank.id_conta} value={bank.id_conta}>
																{bank.banco}
															</option>
														))}
													</select>
													{fieldState.error && (
														<p style={{ color: "red" }}>{fieldState.error.message}</p>
													)}
												</div>
											)}
										/>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default ShowTableInstallments;
